import React from "react";

import { cn } from "@/lib/utils";
import { DASHBOARD_GUTTER, DASHBOARD_MEASURE } from "./dashboardShell";

/**
 * THE WORDMARK BAND: the portal's closing element, mounted ONCE at the shell
 * (`PortalLayout`) so every route ends on it. A full-bleed band, its rule and
 * paper running edge to edge; the wordmark inside is capped to the content
 * measure so it lines up under the body on any route width.
 *
 * Measured: 13px JetBrains Mono at 0.2em, band 42.8 tall (0.8 rule + 14 + 14 +
 * 14). Below 640 the rule swaps `--dc-line-strong` -> `--dc-line` (a real tone
 * swap per `DashboardExposureMobile.dc.html:480`) and the pad re-cuts.
 *
 * THE `action` SLOT hangs a control off the same row, pinned right by its own
 * `ml-auto` (Exposure's band stood 3.6 taller for it). Empty at the shell
 * mount since export moved to the Record head row (Leo, 2026-09-25); kept as
 * the band's one extension point so restoring a control is a prop, not a cut.
 */
export interface DashboardFooterProps {
  /** Pinned right by its own `ml-auto`. */
  action?: React.ReactNode;
}

const DashboardFooter: React.FC<DashboardFooterProps> = ({ action }) => (
  <div className="border-t border-dc-line bg-dc-paper sm:border-dc-line-strong">
    <div
      className={cn(
        DASHBOARD_MEASURE,
        DASHBOARD_GUTTER,
        "flex items-center gap-[14px] pb-3 pt-[9px] sm:py-[14px]",
      )}
    >
      {/* `data-testid` unchanged from the block this replaces, so the shipped
          wordmark test still finds it. */}
      <div
        aria-hidden="true"
        data-testid="portal-dashboard-wordmark"
        className="font-mono text-[13px] uppercase leading-[14px] tracking-[0.2em] text-dc-ink"
      >
        CodeClear
      </div>
      {action}
    </div>
  </div>
);

export default DashboardFooter;
